export const TECHNICAL_DEFINITION_DEFAULTS = {
    type: "http",
    name: "",
    host: "",
    duration: undefined,
    durationUnit: "y",
    isSessionDuration: false,
    purpose: ""
};
export * from "./definitions";
export * from "./compose";
